import apiClient, { strapiApiUrl } from "@/api/api";
import { HzbaStatusCode } from "@/models/ba/interfaces/IBestandsaufnahme";

async function getTemplates() {
  return apiClient.get(`${strapiApiUrl}/vorlage-bestandsaufnahmes`);
}

async function postSurvey(data: any) {
  const body: any = {
    begehungsdatum: data.date,
    gutachter: data.userId,
    status: HzbaStatusCode.ANGELEGT,
    immobilie: data.property,
    vorlage_bestandsaufnahme: data.type,

  }

  if (data.geolocationLat && data.geolocationLon) {
    body.geolocationLat = data.geolocationLat;
    body.geolocationLon = data.geolocationLon;
  }

  if (body.immobilie || body.geolocationLat && body.geolocationLon) {
    return apiClient.post(`${strapiApiUrl}/bestandsaufnahmes`, body);
  } else {
    return Promise.reject(new Error("Either property or geolocation must be provided."));
  }
}

export default {
  getTemplates,
  postSurvey
}
